<div class="widget-shareholding">
    <div class="title">
        <p class="cat text-uppercase">{{ isLang?.sharePricePerformance }}</p>
    </div>
    <div class="text-center">
        <div class="tradingview-widget-container">
            <div id="tradingview_3d5dba"></div>
        </div>
    </div>
</div>
